import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { Sit2Service } from '../../services/http/sit2.service';
import { DatatableComponent } from './../../shared/components/data-table/datatable.component';
import { HeaderAuthComponent } from '../../shared/components/header_auth/header_auth.component';
import { FirmarElectronicamentePendientesICAComponent } from '../firmar_electronicamente_pendientes_ica/firmar_electronicamente_pendientes_ica.component';
import { ModalService } from '../../shared/services/modal.service';


declare let gtag: Function;

@Component({
  selector: 'app-firmar-ica',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HeaderAuthComponent, FirmarElectronicamentePendientesICAComponent],
  templateUrl: './firmar_ica.component.html',
  styleUrl: './firmar_ica.component.scss'
})

export class FirmarICAComponent extends DatatableComponent implements OnInit {

  showViewHTMLComponent = false;
  listActividades = [];
  tabs = [true, false];

  urlsPaso  = {
    dos: this.getAssetUrl('assets/step/imagen-step2.png') 
  }

  getAssetUrl(filename: string): string {
    return `${filename}?v=${Date.now()}`;
  }


  override originalData: any[] = [];

  constructor(private router: Router,
    private sit2Service: Sit2Service,
    private modalService:ModalService,
    private authService: AuthService) {
    super()
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {

    }

    
    const config = this.authService.getValueConfig();
  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }

    this.showViewHTMLComponent = true;
  
    this.applyFilter();

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/por_firmar_ica' });
      } catch (err) { }
    }
  }

  override applyFilter(): void {
    const searchTerm = this.filterTerm.toLowerCase();

    this.currentData = this.originalData.filter(item =>
      String(item.vigencia).toLowerCase().includes(searchTerm) ||
      String(item.nombrePeriodo).toLowerCase().includes(searchTerm) ||
      String(item.nroReferencia).toLowerCase().includes(searchTerm) ||
      String(item.fechaCreacion).toLowerCase().includes(searchTerm) ||
      String(item.fechaPago).toLowerCase().includes(searchTerm) ||
      String(item.valorPagar).toLowerCase().includes(searchTerm)
    );

    this.currentPage = 1;
  }

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: any): void {
    // Si el clic no fue dentro de un dropdown, cierra todos los menús
    const clickedInsideDropdown = targetElement.closest('.dropdown');
    if (!clickedInsideDropdown) {
      if(this.controlCloseAllMenus){
        let temp = [...this.currentData].map((item_local) => {
          return {
            ...item_local,
            $$isMenuOpen: false
          };
        });
        this.currentData = temp;
        this.controlCloseAllMenus = false;
      }
    }

  }


  printForm(obj: any) {
    this.toggleMenuAll();
    const idSoporte = obj.idSoporte;
    const config = this.authService.getValueConfig();
    this.sit2Service.cifrarIdXBarcode(idSoporte).subscribe({
      next: (response) => {
        if (!(response === void 0)) {
          window.open(config.urlFormulario + response.valor);
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Servicio no disponible, por favor intente más tarde");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  };

  irAPagar(obj: any){
    const config = this.authService.getValueConfig();
    window.open(config.urlPSE+"?idSoporte="+obj.idSoporte)
  }

  changeTab(item: number){
    if(item == 1){
      this.tabs[0] = true; 
      this.tabs[1] = false; 
    }else if(item == 2){
      this.tabs[0] = false; 
      this.tabs[1] = true; 
    }
  }

}
